import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import DashboardAdmin from "./../../components/Admin/DashboardAdmin/DashboardAdmin";
import DashboardAdminContext from "../../context/Admin/DashboardAdminContext/DashboardAdminContext";
import AdminLayout from "../../layouts/AdminLayout/AdminLayout";
import EditProfileAdmin from "../../components/Admin/EditProfileAdmin/EditProfileAdmin";
import CategoryAdminContext from "../../context/Admin/CategoryAdminContext/CategoryAdminContext";
import CategoryAdmin from "../../components/Admin/CategoryAdmin/CategoryAdmin";
import CancelingReasonAdmin from "../../components/Admin/CancelingReasonAdmin/CancelingReasonAdmin";
import CancelingReasonAdminContext from "../../context/Admin/CancelingReasonAdminContext/CancelingReasonAdminContext";
import FailingReasonAdmin from "../../components/Admin/FailingReasonAdmin/FailingReasonAdmin";
import FailingReasonAdminContext from "../../context/Admin/FailingReasonAdminContext/FailingReasonAdminContext";
import ReturnUserStatusAdmin from "../../components/Admin/ReturnUserStatusAdmin/ReturnUserStatusAdmin";
import ReturnUserStatusAdminContext from "../../context/Admin/ReturnUserStatusAdminContext/ReturnUserStatusAdminContext";
import EmployerAdminContext from "../../context/Admin/EmployerAdminContext/EmployerAdminContext";
import EmployerAdmin from "../../components/Admin/EmployerAdmin/EmployerAdmin";
import PersonnelAdminContext from "../../context/Admin/PersonnelAdminContext/PersonnelAdminContext";
import PersonnelAdmin from "../../components/Admin/PersonnelAdmin/PersonnelAdmin";
import UserAdminContext from "../../context/Admin/UserAdminContext/UserAdminContext";
import UserAdmin from "../../components/Admin/UserAdmin/UserAdmin";
import OrderAdminContext from "../../context/Admin/OrderAdminContext/OrderAdminContext";
import OrdersAdmin from "../../components/Admin/OrdersAdmin/OrdersAdmin";
import OrderAdmin from "../../components/Admin/OrderAdmin/OrderAdmin";
import ServiceAdmin from "./../../components/Admin/ServiceAdmin/ServiceAdmin";
import ServiceAdminContext from "../../context/Admin/ServiceAdminContext/ServiceAdminContext";
import TaraRefundAdmin from "../../components/Admin/TaraRefundAdmin/TaraRefundAdmin";
import TaraRefundAdminContext from "../../context/Admin/TaraRefundAdminContext/TaraRefundAdminContext";
import LogAdminContext from "../../context/Admin/LogAdminContext/LogAdminContext";
import LogAdmin from "../../components/Admin/LogAdmin/LogAdmin";
import StatisticAdminContext from "../../context/Admin/StatisticAdminContext/StatisticAdminContext";
import StatisticAdmin from "../../components/Admin/StatisticAdmin/StatisticAdmin";
import ProvinceAndCityAdminContext from "../../context/Admin/ProvinceAndCityAdminContext/ProvinceAndCityAdminContext";
import ProvinceAdmin from "../../components/Admin/ProvinceAdmin/ProvinceAdmin";
import CityAdmin from "../../components/Admin/CityAdmin/CityAdmin";
import UseDiscountAdminContext from "../../context/Admin/UseDiscountAdminContext/UseDiscountAdminContext";
import UseDiscountAdmin from "../../components/Admin/UseDiscountAdmin/UseDiscountAdmin";
import DiscountCouponAdmin from "../../components/Admin/DiscountCouponAdmin/DiscountCouponAdmin";
import DiscountCouponAdminContext from "../../context/Admin/DiscountCouponAdminContext/DiscountCouponAdminContext";
import WalletAdminContext from "../../context/Admin/WalletAdminContext/WalletAdminContext";
import WalletAdmin from "../../components/Admin/WalletAdmin/WalletAdmin";
import GroupChargeAdminContext from "../../context/Admin/GroupChargeAdminContext/GroupChargeAdminContext";
import GroupChargeAdmin from "../../components/Admin/GroupChargeAdmin/GroupChargeAdmin";
import EnteredEmployeeCodeAdminContext from "../../context/Admin/EnteredEmployeeCodeAdminContext/EnteredEmployeeCodeAdminContext";
import EnteredEmployeeCodeAdmin from "../../components/Admin/EnteredEmployeeCodeAdmin/EnteredEmployeeCodeAdmin";
import PaymentTransactionAdminContext from "../../context/Admin/PaymentTransactionAdminContext/PaymentTransactionAdminContext";
import PaymentTransactionAdmin from "../../components/Admin/PaymentTransactionAdmin/PaymentTransactionAdmin";
import WalletTransactionAdminContext from "../../context/Admin/WalletTransactionAdminContext/WalletTransactionAdminContext";
import WalletTransactionAdmin from "../../components/Admin/WalletTransactionAdmin/WalletTransactionAdmin";
import InvoiceAdminContext from "../../context/Admin/InvoiceAdminContext/InvoiceAdminContext";
import InvoiceAdmin from "../../components/Admin/InvoiceAdmin/InvoiceAdmin";
import ViolationAdminContext from "../../context/Admin/ViolationsAdminContext/ViolationsAdminContext";
import ViolationsAdmin from "../../components/Admin/ViolationsAdmin/ViolationsAdmin";
import FailureRequestsAdminContext from "../../context/Admin/FailureRequestsAdminContext/FailureRequestsAdminContext";
import FailureRequestsAdmin from "../../components/Admin/FailureRequestsAdmin/FailureRequestsAdmin";
import CriticsSuggestionsAdminContext from "../../context/Admin/CriticsSuggestionsAdminContext/CriticsSuggestionsAdminContext";
import CriticsSuggestionsAdmin from "../../components/Admin/CriticsSuggestionsAdmin/CriticsSuggestionsAdmin";
import SMSTemplateAdminContext from "../../context/Admin/SMSTemplateAdminContext/SMSTemplateAdminContext";
import SMSTemplateAdmin from "../../components/Admin/SMSTemplateAdmin/SMSTemplateAdmin";
import RejectionReasonAdminContext from "../../context/Admin/RejectionReasonAdminContext/RejectionReasonAdminContext";
import RejectionReasonAdmin from "../../components/Admin/RejectionReasonAdmin/RejectionReasonAdmin";
import RecruitmentAdminContext from "../../context/Admin/RecruitmentAdminContext/RecruitmentAdminContext";
import RecruitmentAdmin from "../../components/Admin/RecruitmentAdmin/RecruitmentAdmin";
import ConfigAdmin from "../../components/Admin/ConfigAdmin/ConfigAdmin";
import ConfigAdminContext from "../../context/Admin/ConfigAdminContext/ConfigAdminContext";
import RouletteAdmin from "../../components/Admin/RouletteAdmin/RouletteAdmin";
import RouletteAdminContext from "../../context/Admin/RouletteAdminContext/RouletteAdminContext";
import RouletteResultsAdmin from "../../components/Admin/RouletteResultsAdmin/RouletteResultsAdmin";
import RouletteResultsAdminContext from "../../context/Admin/RouletteResultsAdminContext/RouletteResultsAdminContext";
import AdminAdmin from "../../components/Admin/AdminAdmin/AdminAdmin";
import AdminAdminContext from "../../context/Admin/AdminAdminContext/AdminAdminContext";
import CompareOrdersAdmin from "../../components/Admin/CompareOrdersAdmin/CompareOrdersAdmin";
import CompareOrderAdminContext from "../../context/Admin/CompareOrderAdminContext/CompareOrderAdminContext";
import BackUpAdmin from "../../components/Admin/BackUpAdmin/BackUpAdmin";
import BackUpAdminContext from "../../context/Admin/BackUpAdminContext/BackUpAdminContext";
import ItemsAdmin from "../../components/Admin/ItemsAdmin/ItemsAdmin";
import { setUserInfoAction } from "../../redux/actions/userInfoActions/userInfoActions";
import { setAppConfigsAction } from "./../../redux/actions/appConfigsActions/appConfigsActions";
import { setCitiesAction } from "./../../redux/actions/citiesActions/citiesActions";
import { setPermissionAction } from "../../redux/actions/permissionActions/permissionActions";
import { baseAdminRoute, getCookies } from "../../utils";
import { setSocketActions } from "../../redux/actions/socketActions/socketActions";

const AdminContainer = () => {
  const dispatch = useDispatch();

  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  useEffect(() => {
    if (accessToken) {
      dispatch(setSocketActions(accessToken));
      dispatch(setUserInfoAction());
      dispatch(setCitiesAction());
      dispatch(setAppConfigsAction());
      dispatch(setPermissionAction());
    }
  }, []);

  if (!isLogin) return <Navigate to={baseAdminRoute("/")} />;

  return (
    <AdminLayout>
      <Routes>
        {/* Edit Admin Profile Component */}
        <Route path="/Profile/Edit" element={<EditProfileAdmin />} />

        {/* Statistics Component */}
        <Route
          path="/Statistics"
          element={
            <StatisticAdminContext>
              <StatisticAdmin />
            </StatisticAdminContext>
          }
        />

        {/* Critics Suggestions Component */}
        <Route
          path="/CriticsSuggestions"
          element={
            <CriticsSuggestionsAdminContext>
              <CriticsSuggestionsAdmin />
            </CriticsSuggestionsAdminContext>
          }
        />

        {/* Discount Coupons Component */}
        <Route
          path="/DiscountCoupons"
          element={
            <DiscountCouponAdminContext>
              <DiscountCouponAdmin />
            </DiscountCouponAdminContext>
          }
        />

        {/* Wallets Component */}
        <Route
          path="/Wallets"
          element={
            <WalletAdminContext>
              <WalletAdmin />
            </WalletAdminContext>
          }
        />

        {/* Entered Employee Codes Component */}
        <Route
          path="/EnteredEmployeeCodes"
          element={
            <EnteredEmployeeCodeAdminContext>
              <EnteredEmployeeCodeAdmin />
            </EnteredEmployeeCodeAdminContext>
          }
        />

        {/* Use Discounts Component */}
        <Route
          path="/UseDiscounts"
          element={
            <UseDiscountAdminContext>
              <UseDiscountAdmin />
            </UseDiscountAdminContext>
          }
        />

        {/* Logs Component */}
        <Route
          path="/Logs"
          element={
            <LogAdminContext>
              <LogAdmin />
            </LogAdminContext>
          }
        />

        {/* Services Component */}
        <Route
          path="/Services"
          element={
            <ServiceAdminContext>
              <ServiceAdmin />
            </ServiceAdminContext>
          }
        />

        {/* Tara Refund Component */}
        <Route
          path="/Tara-Refund"
          element={
            <TaraRefundAdminContext>
              <TaraRefundAdmin />
            </TaraRefundAdminContext>
          }
        />

        {/* Official Invoice Component */}
        <Route
          path="/Official-Invoice"
          element={
            <OrderAdminContext isOfficial>
              <OrdersAdmin isOfficial />
            </OrderAdminContext>
          }
        />

        {/* Waiting Payment Orders Component */}
        <Route
          path="/Waiting-Payment-Orders"
          element={
            <OrderAdminContext isWaiting>
              <OrdersAdmin isWaiting />
            </OrderAdminContext>
          }
        />

        {/* User Return Orders Component */}
        <Route
          path="/UserReturnOrders"
          element={
            <OrderAdminContext isUserReturn>
              <OrdersAdmin isUserReturn />
            </OrderAdminContext>
          }
        />

        {/* User Cancel Orders Component */}
        <Route
          path="/UserCancelOrders"
          element={
            <OrderAdminContext isUserCancel>
              <OrdersAdmin isUserCancel />
            </OrderAdminContext>
          }
        />

        {/* Orders Component */}
        <Route
          path="/Orders"
          element={
            <OrderAdminContext>
              <OrdersAdmin />
            </OrderAdminContext>
          }
        />

        {/* Order Component */}
        <Route
          path="/Orders/:orderId"
          element={
            <OrderAdminContext>
              <OrderAdmin />
            </OrderAdminContext>
          }
        />

        {/* User Component */}
        <Route
          path="/Users"
          element={
            <UserAdminContext>
              <UserAdmin />
            </UserAdminContext>
          }
        />

        {/* Compare Order Component */}
        <Route
          path="/CompareOrders"
          element={
            <CompareOrderAdminContext>
              <CompareOrdersAdmin />
            </CompareOrderAdminContext>
          }
        />

        {/* Failure Requests Component */}
        <Route
          path="/FailureRequests"
          element={
            <FailureRequestsAdminContext>
              <FailureRequestsAdmin />
            </FailureRequestsAdminContext>
          }
        />

        {/* Violations Component */}
        <Route
          path="/Violations"
          element={
            <ViolationAdminContext>
              <ViolationsAdmin />
            </ViolationAdminContext>
          }
        />

        {/* Violations Penalty Component */}
        <Route
          path="/Violations-Penalty"
          element={
            <ViolationAdminContext isPenalty>
              <ViolationsAdmin isPenalty />
            </ViolationAdminContext>
          }
        />

        {/* Personnel Component */}
        <Route
          path="/Personnels"
          element={
            <PersonnelAdminContext>
              <PersonnelAdmin />
            </PersonnelAdminContext>
          }
        />

        {/* Group Charge Component */}
        <Route
          path="/GroupCharges"
          element={
            <GroupChargeAdminContext>
              <GroupChargeAdmin />
            </GroupChargeAdminContext>
          }
        />

        {/* Employer Component */}
        <Route
          path="/Employers"
          element={
            <EmployerAdminContext>
              <EmployerAdmin />
            </EmployerAdminContext>
          }
        />

        {/* Canceling Reason Component */}
        <Route
          path="/CancelingReasons"
          element={
            <CancelingReasonAdminContext>
              <CancelingReasonAdmin />
            </CancelingReasonAdminContext>
          }
        />

        {/* Rejection Reason Component */}
        <Route
          path="/RejectionReason"
          element={
            <RejectionReasonAdminContext>
              <RejectionReasonAdmin />
            </RejectionReasonAdminContext>
          }
        />

        {/* Config Component */}
        <Route
          path="/Config"
          element={
            <ConfigAdminContext>
              <ConfigAdmin />
            </ConfigAdminContext>
          }
        />

        {/* Roulette Results Component */}
        <Route
          path="/RouletteResults"
          element={
            <RouletteResultsAdminContext>
              <RouletteResultsAdmin />
            </RouletteResultsAdminContext>
          }
        />

        {/* Roulette Component */}
        <Route
          path="/Roulette"
          element={
            <RouletteAdminContext>
              <RouletteAdmin />
            </RouletteAdminContext>
          }
        />

        {/* Recruitment Component */}
        <Route
          path="/Recruitment"
          element={
            <RecruitmentAdminContext>
              <RecruitmentAdmin />
            </RecruitmentAdminContext>
          }
        />

        {/* Failing Reason Component */}
        <Route
          path="/FailingReasons"
          element={
            <FailingReasonAdminContext>
              <FailingReasonAdmin />
            </FailingReasonAdminContext>
          }
        />

        {/* SMS Template Component */}
        <Route
          path="/SMS-Templates"
          element={
            <SMSTemplateAdminContext>
              <SMSTemplateAdmin />
            </SMSTemplateAdminContext>
          }
        />

        {/* Return User Status Component */}
        <Route
          path="/ReturnUserStatus"
          element={
            <ReturnUserStatusAdminContext>
              <ReturnUserStatusAdmin />
            </ReturnUserStatusAdminContext>
          }
        />

        {/* City Component */}
        <Route
          path="/Cities"
          element={
            <ProvinceAndCityAdminContext>
              <CityAdmin />
            </ProvinceAndCityAdminContext>
          }
        />

        {/* Province Component */}
        <Route
          path="/Provinces"
          element={
            <ProvinceAndCityAdminContext>
              <ProvinceAdmin />
            </ProvinceAndCityAdminContext>
          }
        />

        {/* Category Component */}
        <Route
          path="/Categories"
          element={
            <CategoryAdminContext>
              <CategoryAdmin />
            </CategoryAdminContext>
          }
        />

        {/* Payment Transaction Component */}
        <Route
          path="/PaymentTransaction"
          element={
            <PaymentTransactionAdminContext>
              <PaymentTransactionAdmin />
            </PaymentTransactionAdminContext>
          }
        />

        {/* Transaction Component */}
        <Route
          path="/Transaction"
          element={
            <WalletTransactionAdminContext>
              <WalletTransactionAdmin />
            </WalletTransactionAdminContext>
          }
        />

        {/* Invoice Component */}
        <Route
          path="/Invoice"
          element={
            <InvoiceAdminContext>
              <InvoiceAdmin />
            </InvoiceAdminContext>
          }
        />

        {/* Items Component */}
        <Route path="/Items" element={<ItemsAdmin />} />

        {/* Dashboard Component */}
        <Route
          path="/Dashboard"
          element={
            <DashboardAdminContext>
              <DashboardAdmin />
            </DashboardAdminContext>
          }
        />

        {/* Admin Component */}
        <Route
          path="/Admins"
          element={
            <AdminAdminContext>
              <AdminAdmin />
            </AdminAdminContext>
          }
        />

        {/* Back Up Component */}
        <Route
          path="/BackUps"
          element={
            <BackUpAdminContext>
              <BackUpAdmin />
            </BackUpAdminContext>
          }
        />

        {/* Redirect Not Found Page */}
        <Route
          path="*"
          element={<Navigate to={baseAdminRoute("/Not-Found")} />}
        />
      </Routes>
    </AdminLayout>
  );
};

export default AdminContainer;
